import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../utils/constant";

const ArticleTopBar = ({ label }: { label?: string }) => {
  return (
    <header className="article-topbar">
      <Link to="/" aria-label="Go to home">
        <img
          src={Images.logoIcon}
          alt="DiveBuddies"
          className="article-topbar-logo"
        />
      </Link>
      <p className="article-topbar-label">{label || ""}</p>
      <Link to="/" className="article-close-btn" aria-label="Close article">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M1 1L13 13M13 1L1 13"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </Link>
    </header>
  );
};

export default ArticleTopBar;
